<template>
    <div>
        <RejillaUsuarios></RejillaUsuarios>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRoute } from "vue-router";
import { useIntl } from '@services/i18n'
const emit = defineEmits(['childViewLoaded']);
import { useApi } from '@/.shared/.api/integration';
import { useRouter } from '@/.shared/services/routing-services';
import RejillaUsuarios from "@/components/usuarios/RejillaUsuarios.vue";

const api = useApi();
const intl = useIntl();
const route = useRoute();
const router = useRouter();

onMounted(() => {
    emit('childViewLoaded', route.name);
});
</script>